module.exports = __webpack_public_path__ + "static/img/animales_16.67ec9d4b.jpg";